export default {
    integrations_delete_cerebrumx_title: "Delete Integration",
    integrations_delete_cerebrumx_description: "Are you sure you want to delete the integration?",
    integrations_delete_cerebrumx_success_message: "The integration has been deleted",
    integrations_delete_cerebrumx_error_message: "It was not possible to delete the integration due to an error",
    integrations_delete_cerebrumx_in_use: "The package is linked to some users, change the package of the users and try again",
}